module.exports = __webpack_public_path__ + "img/valve-loop-12.6b8954b6.svg";